import Styles from './Headers.module.scss'
import { HeadersProps } from './Types'
import cx from 'classnames'

const Headers = ({ children, className, style }: HeadersProps) => (
  <div className={cx(Styles.tr, className)} style={style}>
    {children}
  </div>
)

export { Headers }
